import React, { Component } from 'react';
import { withRouter } from 'react-router';

//#region Material Components
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
//#endregion

//#region Internal
import { Primary } from './../../assets/Colors';
//#endregion

//#region Inline Style
const styles = {
    button: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 14px',
        marginBottom: 12,
        border: 'none',
        borderRadius: 6,
        backgroundColor: Primary.ContainerBackground,
        color: Primary.TextColor,
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
        boxShadow: Primary.PanelBoxShadow
    }
};
//#endregion

class BackButton extends Component {
    _handleClick = () => {
        this.props.history.goBack();
    };

    render() {
        const { label = 'Geri Dön', style = {} } = this.props;

        return (
            <button
                type='button'
                onClick={this._handleClick}
                style={{ ...styles.button, ...style }}
            >
                <ArrowBackIcon style={{ fontSize: 18 }} />
                {label}
            </button>
        );
    }
}

export default withRouter(BackButton);
